// 联合会员绑定
import Base from './Base'

export default class memberBindApi extends Base {
  // 获取所有卡片
  static getAllCard() {
    return super.get('/pss/unionCard/getAllCard.json')
  }

  // 获取卡片绑定关系
  static getBindRelation() {
    return super.get('/hotel/joint/getBindRelation.json')
  }

  // 酒店卡片取消绑定
  static cancelBind(params) {
    return super.post('/hotel/joint/unbind.json', params)
  }

  // 联合登录页面是否展示
  static getStyleControl() {
    return super.get('/hotel/joint/styleControl.json')
  }
}
